export const sdbThemeBreakpoints = {
    xs: 0,
    sm: 600,
    md: 905,
    lg: 1240, //
    xl: 1440,
};
export default sdbThemeBreakpoints;
